itsoftApp.createModule("dashAnimation", function () {
    var module = this; 
    var viewWidthEl = document.querySelector(".js-viewport");
    var viewport = itsoftApp.utils.getViewportSize();

    var initAnimation = function (el) {
        var defaultPath = el.querySelector(".page__dashed-path");
        var defaultPath2 = el.querySelector(".page__dashed-path.page__dashed-path-2");
        var maskedPath = el.querySelector(".page__masked-path");

        if (maskedPath) {
            var pathLength = maskedPath.getTotalLength();
            maskedPath.style.strokeDasharray = pathLength;
            maskedPath.style.strokeDashoffset = pathLength;

            defaultPath.style.opacity = "1";
            maskedPath.style.opacity = "1";

            if (viewWidthEl) {
                if (viewport > 1600 && defaultPath.hasAttribute("vector-effect")) {
                    defaultPath.removeAttribute("vector-effect");
                    maskedPath.removeAttribute("vector-effect");
                }
            }

            requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                    maskedPath.style.transition = "stroke-dashoffset 1s ease-in";
                    maskedPath.style.strokeDashoffset = 0;
                });
            });
        } else if (defaultPath && !maskedPath) {
            var pathLength = defaultPath.getTotalLength();
            defaultPath.style.strokeDasharray = pathLength;
            defaultPath.style.strokeDashoffset = pathLength;

            defaultPath.style.opacity = "1";

            if (defaultPath2) {
                var pathLength2 = defaultPath2.getTotalLength();
                defaultPath2.style.strokeDasharray = pathLength2;
                defaultPath2.style.strokeDashoffset = pathLength2;

                defaultPath2.style.opacity = "1";       
            } 

            requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                    defaultPath.style.transition = "stroke-dashoffset 1s ease-in";
                    defaultPath.style.strokeDashoffset = 0;

                    if (defaultPath2) {
                        defaultPath2.style.transition = "stroke-dashoffset 1s 1s ease-in";
                        defaultPath2.style.strokeDashoffset = 0;
                    } 
                });
            });
        }
    }

    var stopArray = [];

    var addDashLength = function (strokeEl) {
        // window.stopObject.value = 0;

        if (stopArray.length > 0) {
            stopArray[0].value = true;
            stopArray.splice(0, 1);
        }

        if (viewport < 768) {
            strokeEl.setAttribute("stroke-width", "3");
        }

        if (viewport >= 1280) {
            var strokeElLength = strokeEl.getTotalLength();
        } else {
            var strokeElLength = strokeEl.getTotalLength() * strokeEl.getBoundingClientRect().width/strokeEl.getBBox().width;
        }
        strokeEl.style.strokeDasharray = strokeElLength;
        strokeEl.style.strokeDashoffset = strokeElLength;
    }

    var startDashAnimation = function (strokeEl, time) {
        if (viewport >= 1280) {
            var strokeElLength = strokeEl.getTotalLength();
        } else {
            var strokeElLength = strokeEl.getTotalLength() * strokeEl.getBoundingClientRect().width/strokeEl.getBBox().width;
        }

        /* Добавляем анимацию в очередь, чтобы её можно было остановить перключением флажка при клике на другой элемент */
        stopArray.push(itsoftApp.modules.animations.callback({
                draw: function (progress, timeFraction) { /* анимируем в зависимости от времени и временной функции */
                    strokeEl.style.strokeDashoffset = strokeElLength - (progress * strokeElLength);

                    if (timeFraction == 1) {
                        strokeEl.style.strokeDashoffset = strokeElLength;
                    }
                },
                timing: function(timeFraction) {
                    return 1 - Math.cos((timeFraction * Math.PI) / 2);
                },
                duration: 6000
            }, strokeEl));
    }

    module.initAnimation = initAnimation;
    module.addDashLength = addDashLength;
    module.startDashAnimation = startDashAnimation;
});